// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_container__J5hKm {
  width: 100%;
  max-height: 90vh;
  padding: 18px 0px;
}

.styles_contactContainer__pULwe {
  border: 1px solid #eeeeee;
  margin-bottom: 8px;
  border-radius: 10px;
}

.styles_contactContainer__pULwe > div {
  width: 23%;
  margin: 10px 1%;
}

.styles_section__YQQJo {
  width: 100%;
  margin-bottom: 50px;
}

.styles_section__YQQJo input, .styles_section__YQQJo > div > div {
  width: 100% !important;
}

.styles_sendButton__gZpkn {
  border-radius: 5px;
  width: 100%;
  height: auto;
  color: #fff;
  margin: 0 !important;
  border: unset !important;
  margin-bottom: 15px !important;
}

.styles_formContainer__TcuCa {
  border-left-width: 2px;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
  width: auto;
  display: flex;
}

.styles_text_area__ZOAm\\+ {
  width: 100%;
  font-size: 14px;
  color: black;
  outline: none;
  border-radius: 10px;
  background-color: unset !important;
}

.styles_wrapper__kNT6s {
  border-radius: unset;
}

.styles_text_area_border_yellow__i-yQu {
  width: 100%;
  height: 100%;
  padding: 20px 10px 0 0;
  font-size: 14px;
  color: black;
  outline: none;
  border-radius: 10px;
  border: 1px solid #ff9315;
}

.styles_submitItem__Le5RW {
  margin: 0 5px !important;
  cursor: pointer;
  flex-direction: row-reverse;
  border-radius: 6px !important;
  background-color: inherit !important;
  font-size: 16px !important;
  line-height: 25px !important;
  height: auto !important;
}

.styles_kidzyButton__p7uYw {
  border: none;
  color: #713be1 !important;
  opacity: 0.8;
}

.styles_kidzyText__68m7G {
  opacity: 0.8;
  font-size: 16px !important;
  line-height: 25px !important;
  color: #713be1 !important;
  height: auto;
  text-align: center;
  width: 100%;
}

.styles_submitItem__Le5RW span {
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 25px;
}

.styles_formTitle__eUHG- {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  padding-bottom: 1em;
}

.styles_forgetText__XFq7S {
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  padding-top: 4px;
  margin-bottom: 1em;
}

.styles_inputError__pTnDr {
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #ff9315;
  margin-top: 8px;
}

.styles_serverError__mBtTX {
  background: #ff9315;
  border-radius: 4px;
  color: #ffffff;
  width: 100%;
  height: auto;
  padding: 0.5em;
  margin-bottom: 1em;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}

.styles_serverError__mBtTX span {
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 20px;
  padding: 0 2px;
}

.styles_flexStyle__\\+zR3m {
  flex-direction: row;
  margin: 40px 0;
}

.styles_inputStyle__JDYCC {
  width: 353px !important;
  height: 100%;
}

@media only screen and (max-width: 1024px) {
  .styles_flexStyle__\\+zR3m {
    flex-direction: column;
  }
  .styles_flexStyle__\\+zR3m > div:nth-child(2) {
    margin: 0 auto;
    margin-top: 20px;
  }
  .styles_formContainer__TcuCa {
    border-left-width: 0px;
  }
}
@media only screen and (max-width: 800px) {
  .styles_container__J5hKm {
    width: 100%;
  }
  .styles_force_media__XUzy\\+ {
    padding: 0 10px 0 10px !important;
  }
  .styles_flexStyle__\\+zR3m {
    flex-direction: column-reverse;
    overflow: auto;
    height: calc(100vh - 138px);
    padding-bottom: 20px;
    scrollbar-color: #e3e3e3 transparent;
    scrollbar-width: 8px;
  }
  .styles_flexStyle__\\+zR3m::-webkit-scrollbar {
    background: transparent;
    width: 8px;
  }
  .styles_flexStyle__\\+zR3m::-webkit-scrollbar-thumb {
    background-color: #e3e3e3;
    border-radius: 100px;
    height: 8px;
  }
  .styles_flexStyle__\\+zR3m > div:nth-child(2) {
    margin: 0;
    margin-top: 20px;
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
  .styles_inputStyle__JDYCC {
    width: 100% !important;
  }
  .styles_bottomText__SEo19 {
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 19px;
    margin: 0;
    padding: 0;
    color: #000000;
    margin-left: 8px;
  }
  .styles_formContainer__TcuCa {
    border-left-width: 0;
    padding-left: 0;
    padding-right: 0;
  }
  .styles_mobileSignup__PYNII {
    justify-content: center;
    flex-direction: row;
    align-items: center;
    width: auto;
    display: flex;
    margin-top: 14px;
    margin-bottom: 14px;
  }
  .styles_mobileSignup__PYNII > span {
    width: auto !important;
  }
  .styles_submitItem__Le5RW {
    border: none;
    font-style: normal !important;
    font-weight: 500 !important;
    font-size: 12px !important;
    line-height: 19px !important;
    width: 100%;
    border: unset !important;
  }
}
@media only screen and (max-width: 1200px) {
  .styles_contactContainer__pULwe > div {
    width: 31%;
    margin: 10px 1%;
  }
}
@media only screen and (max-width: 700px) {
  .styles_contactContainer__pULwe > div {
    width: 48%;
    margin: 10px 1%;
  }
}
@media only screen and (max-width: 400px) {
  .styles_contactContainer__pULwe > div {
    width: 98%;
    margin: 10px 1%;
  }
}`, "",{"version":3,"sources":["webpack://./../src/renderer/components/UpdateprofileModal/styles.module.scss"],"names":[],"mappings":"AACE;EAEE,WAAA;EACD,gBAAA;EACA,iBAAA;AADH;;AAOE;EACE,yBAAA;EACA,kBAAA;EACA,mBAAA;AAJJ;;AAME;EACE,UAAA;EACA,eAAA;AAHJ;;AAKC;EACC,WAAA;EACA,mBAAA;AAFF;;AAIC;EACC,sBAAA;AADF;;AAGC;EACC,kBAAA;EAEA,WAAA;EACA,YAAA;EACA,WAAA;EACA,oBAAA;EACA,wBAAA;EACA,8BAAA;AADF;;AAGE;EACE,sBAAA;EACA,oBAAA;EACA,qBAAA;EACA,2BAAA;EACA,uBAAA;EACA,sBAAA;EACA,WAAA;EACA,aAAA;AAAJ;;AAGE;EACE,WAAA;EAIA,eAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,kCAAA;AAHJ;;AAME;EAIE,oBAAA;AANJ;;AASE;EACE,WAAA;EACA,YAAA;EAEA,sBAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;AAPJ;;AAmBE;EACE,wBAAA;EACA,eAAA;EACA,2BAAA;EAEA,6BAAA;EACA,oCAAA;EAEA,0BAAA;EACA,4BAAA;EAEA,uBAAA;AAnBJ;;AAqBE;EACE,YAAA;EAEA,yBAAA;EACA,YAAA;AAnBJ;;AAqBE;EAEE,YAAA;EACA,0BAAA;EACA,4BAAA;EAEA,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;AApBJ;;AAsBE;EAEE,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;AApBJ;;AAuBE;EACE,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EAEA,mBAAA;AArBJ;;AAwBE;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EAEA,gBAAA;EACA,kBAAA;AAtBJ;;AAyBE;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;AAtBJ;;AAyBE;EACE,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,mBAAA;AAtBJ;;AAyBE;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAtBJ;;AAyBE;EACE,mBAAA;EACA,cAAA;AAtBJ;;AAyBE;EACE,uBAAA;EAEA,YAAA;AAvBJ;;AA0BE;EACE;IACE,sBAAA;EAvBJ;EA0BE;IACE,cAAA;IACA,gBAAA;EAxBJ;EA0BE;IACE,sBAAA;EAxBJ;AACF;AA4BE;EACE;IAEE,WAAA;EA3BJ;EA6BE;IACE,iCAAA;EA3BJ;EA6BE;IACE,8BAAA;IACA,cAAA;IACA,2BAAA;IACA,oBAAA;IAGA,oCAAA;IACA,oBAAA;EA7BJ;EA+BE;IAEE,uBAAA;IACA,UAAA;EA9BJ;EAiCE;IACE,yBAAA;IACA,oBAAA;IACA,WAAA;EA/BJ;EAkCE;IACE,SAAA;IACA,gBAAA;IACA,oBAAA;IACA,qBAAA;EAhCJ;EAmCE;IACE,sBAAA;EAjCJ;EAmCE;IACE,kBAAA;IACA,gBAAA;IACA,eAAA;IACA,iBAAA;IACA,SAAA;IACA,UAAA;IAEA,cAAA;IACA,gBAAA;EAlCJ;EAoCE;IACE,oBAAA;IACA,eAAA;IACA,gBAAA;EAlCJ;EAoCE;IACE,uBAAA;IACA,mBAAA;IACA,mBAAA;IACA,WAAA;IACA,aAAA;IACA,gBAAA;IACA,mBAAA;EAlCJ;EAoCE;IACE,sBAAA;EAlCJ;EAoCE;IACE,YAAA;IACA,6BAAA;IACA,2BAAA;IACA,0BAAA;IACA,4BAAA;IACA,WAAA;IACA,wBAAA;EAlCJ;AACF;AAsCA;EACE;IACE,UAAA;IACA,eAAA;EApCF;AACF;AAuCA;EACE;IACE,UAAA;IACA,eAAA;EArCF;AACF;AAwCA;EACE;IACE,UAAA;IACA,eAAA;EAtCF;AACF","sourcesContent":["\n  .container{\n    // width:60vw;\n    width:100%;\n   max-height:90vh;\n   padding:18px 0px;\n  }\n  // .contactContainer{\n  //   max-height: 163px;\n  //   overflow-y: auto;\n  // }\n  .contactContainer{\n    border: 1px solid #eeeeee;\n    margin-bottom: 8px;\n    border-radius:10px;\n  }\n  .contactContainer > div{\n    width:23%;\n    margin:10px 1%;\n  }\n .section{\n  width:100%;\n  margin-bottom:50px;\n }\n .section input, .section>div>div{\n  width:100% !important;\n }\n .sendButton{\n  border-radius: 5px;\n  // background: #075B52;\n  width:100%;\n  height: auto;\n  color: #fff;\n  margin:0 !important;\n  border : unset !important;\n  margin-bottom:15px !important;\n }\n  .formContainer {\n    border-left-width: 2px;\n    padding-left: 1.5rem;\n    padding-right: 1.5rem;\n    justify-content: flex-start;\n    align-items: flex-start;\n    flex-direction: column;\n    width: auto;\n    display: flex;\n  \n  }\n  .text_area {\n    width: 100%;\n    // height: 100%;\n    // background-color: #fafafa;\n    // padding: 20px 10px 0 0;\n    font-size: 14px;\n    color: black;\n    outline: none;\n    border-radius: 10px;\n    background-color:  unset !important;\n    // border: 1px solid #eeeeee;\n  }\n  .wrapper{\n    // border: unset;\n    // border:unset !important;\n    // border-bottom: 1px solid rgba(0, 0, 0, 0.50) !important;\n    border-radius: unset;\n    // margin-top:50px;\n  }\n  .text_area_border_yellow {\n    width: 100%;\n    height: 100%;\n    // background-color: #fafafa;\n    padding: 20px 10px 0 0;\n    font-size: 14px;\n    color: black;\n    outline: none;\n    border-radius: 10px;\n    border: 1px solid #ff9315;\n  }\n  .section:nth-child(1){\n    // margin-:0px !important;\n  }\n  // .text_area::placeholder{\n  //   color: #bababa;\n  //   font-style: normal;\n  //   font-weight: 400;\n  //   font-size: 14px;\n  // }\n  \n  .submitItem {\n    margin: 0 5px !important;\n    cursor: pointer;\n    flex-direction: row-reverse;\n    // border: 1px solid #d8000d !important;\n    border-radius: 6px !important;\n    background-color: inherit !important;\n  \n    font-size: 16px !important;\n    line-height: 25px !important;\n    // color: #e30813 !important;\n    height: auto !important;\n  }\n  .kidzyButton{\n    border:none;\n    // color: rgb(41 15 188) !important;\n    color:#713be1 !important;\n    opacity:0.8;\n  }\n  .kidzyText{\n    // color: rgb(41 15 188) !important;\n    opacity:0.8;\n    font-size: 16px !important;\n    line-height: 25px !important;\n    // color: #e30813 !important;\n    color:#713be1 !important;\n    height: auto;\n    text-align:center;\n    width:100%;\n  }\n  .submitItem span {\n    // color: #e30813 !important;\n    font-style: normal;\n    font-weight: bold;\n    font-size: 16px;\n    line-height: 25px;\n  }\n  \n  .formTitle {\n    font-style: normal;\n    font-weight: normal;\n    font-size: 14px;\n    line-height: 20px;\n    // color: #707070;\n    padding-bottom: 1em;\n  }\n  \n  .forgetText {\n    font-style: normal;\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 20px;\n    // color: #d8000d;\n    padding-top: 4px;\n    margin-bottom: 1em;\n  }\n  \n  .inputError {\n    font-style: normal;\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 20px;\n    color: #ff9315;\n    margin-top: 8px;\n  }\n  \n  .serverError {\n    background: #ff9315;\n    border-radius: 4px;\n    color: #ffffff;\n    width: 100%;\n    height: auto;\n    padding: 0.5em;\n    margin-bottom: 1em;\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-start;\n    align-items: center;\n  }\n  \n  .serverError span {\n    font-style: normal;\n    font-weight: 500;\n    font-size: 12px;\n    line-height: 20px;\n    padding: 0 2px;\n  }\n  \n  .flexStyle {\n    flex-direction: row;\n    margin: 40px 0;\n  }\n  \n  .inputStyle {\n    width: 353px !important;\n    // height: 44px;\n    height:100%;\n  }\n  \n  @media only screen and (max-width: 1024px) {\n    .flexStyle {\n      flex-direction: column;\n    }\n  \n    .flexStyle > div:nth-child(2) {\n      margin: 0 auto;\n      margin-top: 20px;\n    }\n    .formContainer {\n      border-left-width: 0px;\n    }\n  }\n  \n  // @media only screen and (max-width: 576px) {\n  @media only screen and (max-width: 800px) {\n    .container{\n      // width:90vw;\n      width:100%;\n    }\n    .force_media {\n      padding: 0 10px 0 10px !important;\n    }\n    .flexStyle {\n      flex-direction: column-reverse;\n      overflow: auto;\n      height: calc( 100vh - 138px);\n      padding-bottom: 20px;\n    \n  \n      scrollbar-color: #e3e3e3 transparent;\n      scrollbar-width: 8px;\n    }\n    .flexStyle::-webkit-scrollbar {\n    \n      background: transparent;\n      width: 8px;\n    }\n    \n    .flexStyle::-webkit-scrollbar-thumb {\n      background-color: #e3e3e3;\n      border-radius: 100px;\n      height: 8px;\n    }\n  \n    .flexStyle > div:nth-child(2) {\n      margin: 0;\n      margin-top: 20px;\n      padding-left: 1.5rem;\n      padding-right: 1.5rem;\n    }\n  \n    .inputStyle {\n      width: 100% !important;\n    }\n    .bottomText {\n      font-style: normal;\n      font-weight: 400;\n      font-size: 12px;\n      line-height: 19px;\n      margin: 0;\n      padding: 0;\n  \n      color: #000000;\n      margin-left: 8px;\n    }\n    .formContainer {\n      border-left-width: 0;\n      padding-left: 0;\n      padding-right: 0;\n    }\n    .mobileSignup {\n      justify-content: center;\n      flex-direction: row;\n      align-items: center;\n      width: auto;\n      display: flex;\n      margin-top: 14px;\n      margin-bottom: 14px;\n    }\n    .mobileSignup > span {\n      width: auto !important;\n    }\n    .submitItem {\n      border: none;\n      font-style: normal !important;\n      font-weight: 500 !important;\n      font-size: 12px !important;\n      line-height: 19px !important;\n      width: 100%;\n      border: unset !important;\n    }\n  }\n  \n\n@media only screen and (max-width: 1200px) {\n  .contactContainer > div{\n    width:31%;\n    margin:10px 1%;\n  }\n}\n\n@media only screen and (max-width: 700px) {\n  .contactContainer > div{\n    width:48%;\n    margin:10px 1%;\n  }\n}\n\n@media only screen and (max-width: 400px) {\n  .contactContainer > div{\n    width: 98%;\n    margin:10px 1%;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles_container__J5hKm`,
	"contactContainer": `styles_contactContainer__pULwe`,
	"section": `styles_section__YQQJo`,
	"sendButton": `styles_sendButton__gZpkn`,
	"formContainer": `styles_formContainer__TcuCa`,
	"text_area": `styles_text_area__ZOAm+`,
	"wrapper": `styles_wrapper__kNT6s`,
	"text_area_border_yellow": `styles_text_area_border_yellow__i-yQu`,
	"submitItem": `styles_submitItem__Le5RW`,
	"kidzyButton": `styles_kidzyButton__p7uYw`,
	"kidzyText": `styles_kidzyText__68m7G`,
	"formTitle": `styles_formTitle__eUHG-`,
	"forgetText": `styles_forgetText__XFq7S`,
	"inputError": `styles_inputError__pTnDr`,
	"serverError": `styles_serverError__mBtTX`,
	"flexStyle": `styles_flexStyle__+zR3m`,
	"inputStyle": `styles_inputStyle__JDYCC`,
	"force_media": `styles_force_media__XUzy+`,
	"bottomText": `styles_bottomText__SEo19`,
	"mobileSignup": `styles_mobileSignup__PYNII`
};
export default ___CSS_LOADER_EXPORT___;
